module.exports = __webpack_public_path__ + "assets/img/logo2.af850742.png";